import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=7e296e48"
import script from "./Insights.vue?vue&type=script&lang=js"
export * from "./Insights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports